document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;

  function updateChatPosition() {
    const banner = document.querySelector('.cookieconsent-wrapper.isense-cookieconsent-wrapper');
    if (banner) {
      const height = banner.offsetHeight;
      body.style.setProperty('--cookie-banner-height', height + 'px');
    } else {
      body.style.setProperty('--cookie-banner-height', '0px');
    }
  }

  updateChatPosition();

  const observer = new MutationObserver(updateChatPosition);
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('resize', updateChatPosition);
});